import { render } from "./blog-details-sidebar-left.vue?vue&type=template&id=8db82a2c"
import script from "./blog-details-sidebar-left.vue?vue&type=script&lang=js"
export * from "./blog-details-sidebar-left.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__